/* eslint-disable no-unused-vars */
export * from './client'
import { CHAINS } from '@emberswap/emberswap-sdk2/dist/constants'
import { Chain, configureChains } from 'wagmi'
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'

export const { publicClient } = configureChains(CHAINS as Chain[], [
  jsonRpcProvider({
    rpc: (chain: any) => {
      if (!!process.env.NEXT_PUBLIC_NODE_PRODUCTION) {
        return { http: process.env.NEXT_PUBLIC_NODE_PRODUCTION }
      }
      return { http: chain.rpcUrls.default }
    },
  }),
])
